import {
  MainSpecializations,
  SpecialistData,
  SpecialistLevel,
} from "./TypeSpecialist";
import { GeneralMultiLangText, TypeUserData } from "./TypeUsers";

export enum SubscriptionType {
  DISCOUNT = "discount",
  SESSION_VOLUME = "sessionVolume",
}

export type FlexPassParamsAvailable = {
  totalAmount: number;
  languages: { value: string; choosable: boolean }[];
  mainSpecializations: {
    choosable: boolean;
    value: MainSpecializations;
  }[];
  levels: {
    choosable: boolean;
    value: SpecialistLevel;
  }[];
};

export type FlexPassSubscription = {
  _id: string;
  title: { text: string; language: string }[];
  description?: { text: string; language: string }[];
  language: string;
  mainSpecialization: MainSpecializations;
  level: SpecialistLevel;
  startDate: string;
  endDate: string;
  cost: number;
  baseCost?: number;
  duration: number;
  type: SubscriptionType;
  isActive: boolean;
  advantages?: string[];
  isUniversal: boolean;
  // For DISCOUNT type
  sessionDiscount?: number;
  talziCommissionPercent?: number;

  // For SESSION_VOLUME type
  amountOfSessions?: number;
  firstSessionPayout?: number;
  repeatSessionPayout?: number;

  clients: TypeUserData[];
  specialists: SpecialistData[];
  entryCodes: {
    code: string;
    forSpecialistUser: {
      _id: string;
      name: GeneralMultiLangText[];
      surname: GeneralMultiLangText[];
    };
    forSpecialist: string;
    isAccepted: boolean;
    isRejected: boolean;
    sentAt: Date;
    answeredAt?: Date;
  }[];
};

export type NewFlexPass = {
  title: { text: string; language: string }[];
  description?: { text: string; language: string }[];
  language: string;
  mainSpecialization: string;
  level: string;
  startDate: Date;
  endDate: Date;
  cost: number;
  baseCost?: number | null;
  duration: number;
  type: SubscriptionType;
  advantages?: string[];
  isUniversal: boolean;
  // For DISCOUNT type
  sessionDiscount?: number;
  talziCommissionPercent?: number;

  // For SESSION_VOLUME type
  amountOfSessions?: number;
  firstSessionPayout?: number;
  repeatSessionPayout?: number;
};

export type FlexPassFilteres = {
  language?: string[];
  mainSpecialization?: string[];
  level?: string[];
  isActive?: boolean;
  startDate?: { from?: Date; to?: Date };
  endDate?: { from?: Date; to?: Date };
  type?: SubscriptionType;
  page: number;
  limit: number;
};
